import { blockScrollOnBody, releaseScrollOnBody } from 'utils/body-lock'

const addOnclickToImg = (): void => {
  const $imgPosts = document.querySelectorAll('.imgPost')

  $imgPosts.forEach((element) => {
    element.setAttribute('data-post-img', '')
    element.addEventListener('click', createElements)
  })
}

const minimalizeImg = (): void => {
  const $backgoundElement = document.querySelector<HTMLDivElement>('[data-lightbox-background]')
  const $closeButton = document.querySelector<HTMLAnchorElement>('[data-lightbox-close-button]')
  const $imgPost = document.querySelectorAll<HTMLElement>('[data-post-img]')

  if ($backgoundElement) {
    $backgoundElement.remove()
  }

  if ($closeButton) {
    $closeButton.remove()
  }

  if ($imgPost) {
    $imgPost.forEach((img) => {
      img.classList.remove('wide')
    })
  }

  document.removeEventListener('click', handleClick)
  releaseScrollOnBody()
}

const handleClick = (event: Event): void => {
  const $backgroundContainer = event.target as HTMLElement
  if ($backgroundContainer.matches('.lightbox')) {
    minimalizeImg()
  }
}

const closeOnEscButton = (event: KeyboardEvent): void => {
  if (event.defaultPrevented) return
  if (event.key === 'Escape') {
    minimalizeImg()
  }
}

const createElements = (event: Event): void => {
  const $clickedImg = event.target as HTMLElement
  const openedBacklight = $clickedImg.classList.contains('wide')
  if (!openedBacklight) {
    document.addEventListener('click', handleClick)

    const $background = document.createElement('div')
    const $closeButton = document.createElement('a')

    $background.setAttribute('data-lightbox-background', '')
    $closeButton.setAttribute('data-lightbox-close-button', '')

    $closeButton.addEventListener('click', minimalizeImg)
    document.addEventListener('keydown', closeOnEscButton)

    document.body.appendChild($background).classList.add('lightbox')
    document.body.appendChild($closeButton).classList.add('anchor')

    $clickedImg.classList.add('wide')

    blockScrollOnBody()
  }
}

export default addOnclickToImg
